<template>
  <v-flex style="text-align: center;">
    <v-btn class="log-button" fab @click="toggle()" :color="getColor('lighten-2')">
      <transition name="slide-fade" mode="out-in">
        <v-progress-circular v-if="states.loadingResults" :color="getColor()" indeterminate />
        <v-icon :color="getColor()" v-else-if="states.errorResults">help_outline</v-icon>
        <span v-else :key="count">{{ numberWithCommas(count) }}</span>
      </transition>
    </v-btn>
    <div class="spaced-label-2">
      <span class="clickable" @click="toggle()">
        <v-icon small>{{ this.active ? 'visibility' : 'visibility_off' }}</v-icon>
        {{ label }}s
      </span>
    </div>
  </v-flex>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import { numberWithCommas } from '@/helpers/numbers'
  const ingestionResults = createNamespacedHelpers('reviewingestionresults')

  export default {
    props: {
      active: Boolean,
      count: Number,
      label: String,
      color: String,
    },
    computed: {
      ...ingestionResults.mapState(['states']),
    },
    methods: {
      numberWithCommas,
      toggle() {
        this.$emit('update:active', !this.active)
      },
      getColor(suffix) {
        if (this.active) return `${this.color} ${suffix}`
        else return `#ddd ${suffix}`
      },
    },
  }
</script>

<style scoped>
  .log-button {
    box-shadow: 2px 2px 12px hsla(0, 0, 0, 0.2) !important;
    color: black !important;
    font-weight: 200 !important;
    font-size: 22px !important;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .4s cubic-bezier(0.6, 0.1, 0.4, 0.6);
  }

  .slide-fade-enter,
  .slide-fade-leave-to

  /* .slide-fade-leave-active for <2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
  }
</style>